import React from 'react';
import { RadioInputProps } from '@/components/radio-group/types';

export function RadioGroup({
  label,
  name,
  options,
  value,
  onChange,
  spacingTop,
  spacingBottom,
  errorMessage,
}: RadioInputProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(event.target.value);
  };

  // Separate options into odd and even for splitting when needed
  const oddOptions = options.filter((_, index) => index % 2 !== 0);
  const evenOptions = options.filter((_, index) => index % 2 === 0);

  const renderOptions = (optionsArray: typeof options) =>
    optionsArray.map((option) => (
      <label key={option.value} className="flex space-x-2">
        <input
          type="radio"
          id={`radio-${name}-${option.value}`}
          name={name}
          value={option.value}
          checked={value === option.value}
          onChange={handleChange}
          className="flex-shrink-0 text-brand-700"
        />
        {option.link ? (
          <a
            href={option.link}
            className="flex text-sm font-medium leading-tight text-brand-700"
            target="_blank"
            rel="noopener noreferrer"
          >
            {option.label}
          </a>
        ) : (
          <span className="flex text-sm font-medium leading-tight text-brand-700">
            {option.label}
          </span>
        )}
      </label>
    ));

  return (
    <div className={`mx-auto w-full`}>
      <fieldset className="space-y-2">
        <legend className="block text-sm font-medium text-brand-700">
          {label}
        </legend>
        <div className="flex gap-6">
          {options.length <= 2 ? (
            // Single div for 2 or fewer options
            <div className="flex w-fit gap-4">{renderOptions(options)}</div>
          ) : (
            // Two divs for more than 2 options
            <>
              <div className="flex w-1/2 flex-col gap-2">
                {renderOptions(evenOptions)}
              </div>
              <div className="flex w-1/2 flex-col gap-2">
                {renderOptions(oddOptions)}
              </div>
            </>
          )}
        </div>
        {errorMessage && (
          <p className="mt-2 text-sm text-red-100" role="alert">
            {errorMessage}
          </p>
        )}
      </fieldset>
    </div>
  );
}
